<mat-toolbar
  class="d-flex justify-content-between align-items-center px-3 py-0 custom-toolbar-shadow"
  style="
    background-image: linear-gradient(to right, rgb(216, 45, 45), #8b0000);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 900;
    color: white;
    padding: 0.5rem;
    height: 50px;
  "
>
  <!-- Left logo -->
  <div
    class="d-flex align-items-center"
    [routerLink]="'/'"
    style="cursor: pointer"
  >
    <img
      src="/image.png"
      alt="Logo"
      style="height: 35px; margin-right: 0.5rem"
    />
    <span class="fw-bold fs-5">PHE</span>
  </div>

  <!-- Center Menu -->
  <div *ngIf="!isLandingPage" class="d-flex align-items-center gap-4">
    <div
      *ngFor="let key of menuKeys"
      class="nav-item-wrapper"
      (mouseenter)="onMouseEnter(key)"
      (mouseleave)="onMouseLeave()"
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin"
    >
      <!-- Main Menu Item -->
      <div class="nav-item" [ngClass]="{ 'active-menu': isActive(key) }">
        {{ key }}
      </div>

      <!-- Submenu Overlay -->
      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="hoveredMenu === key"
        [cdkConnectedOverlayPositions]="[
          {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top'
          }
        ]"
      >
        <div
          class="submenu-container"
          (mouseenter)="onSubmenuContainerMouseEnter()"
          (mouseleave)="onSubmenuContainerMouseLeave()"
        >
          <!-- Inside your submenu-container ng-template -->
          <ng-container *ngFor="let item of filteredMenu[key]">
            <div
              class="submenu-item-wrapper"
              (mouseenter)="onSubMenuMouseEnter(item)"
              (mouseleave)="hoveredSubMenu = null"
            >
              <!-- Parent Submenu Item -->
              <div
                class="submenu-item"
                [class.disabled-submenu-item]="item.disabled"
                (click)="navigateMenuItem(item)"
              >
                <mat-icon class="me-2">{{ item.icon }}</mat-icon>
                {{ item.name }}
                <mat-icon *ngIf="item.children" style="margin-left: auto"
                  >chevron_right</mat-icon
                >
              </div>

              <!-- Nested Submenu (2nd level) -->
              <div
                class="nested-submenu"
                *ngIf="item.children && hoveredSubMenu === item.name"
              >
                <div
                  *ngFor="let child of item.children"
                  class="submenu-item-wrapper"
                  (mouseenter)="hoveredChildMenu = child.name"
                  (mouseleave)="hoveredChildMenu = null"
                >
                  <!-- Second-level item -->
                  <div
                    class="submenu-item"
                    [class.disabled-submenu-item]="child.disabled"
                    (click)="navigateMenuItem(child)"
                  >
                    <mat-icon class="me-2">{{ child.icon }}</mat-icon>
                    {{ child.name }}
                    <mat-icon *ngIf="child.children" style="margin-left: auto"
                      >chevron_right</mat-icon
                    >
                  </div>

                  <!-- Third-level submenu -->
                  <div
                    class="nested-submenu"
                    *ngIf="child.children && hoveredChildMenu === child.name"
                  >
                    <div
                      *ngFor="let grandchild of child.children"
                      class="submenu-item"
                      [class.disabled-submenu-item]="grandchild.disabled"
                      (click)="navigateMenuItem(grandchild)"
                    >
                      <mat-icon class="me-2">{{ grandchild.icon }}</mat-icon>
                      {{ grandchild.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-template>
    </div>
  </div>

  <!-- Right Actions -->
  <div class="d-flex align-items-center gap-3">
    <div *ngIf="shouldShowLastUpdated()">
      {{ getLastUpdatedLabel() }}
    </div>
    <app-chat-assist></app-chat-assist>
    <button
      mat-icon-button
      class="transparent-icon-button"
      title="Home"
      [routerLink]="'/'"
    >
      <mat-icon class="icon">home</mat-icon>
    </button>
    <button
      mat-icon-button
      class="transparent-icon-button"
      [matMenuTriggerFor]="notificationMenu"
      title="Notifications"
      [matBadge]="getUnreadNotificationCount()"
      [matBadgeHidden]="getUnreadNotificationCount() === 0"
      matBadgeColor="warn"
    >
      <mat-icon class="icon custom-badge">notifications</mat-icon>
    </button>
    <mat-menu #notificationMenu="matMenu" class="notification-menu" xPosition="before">
      <div class="notification-header">
        <h3>Notifications</h3>
        <button mat-button color="primary" (click)="markAllAsRead()" [disabled]="getUnreadNotificationCount() === 0">
          Mark all as read
        </button>
      </div>

      <ng-container *ngIf="notifications.length > 0; else noNotifications">
        <ng-container *ngFor="let notification of notifications; let last = last">
          <div
            class="notification-item"
            (click)="onNotificationClick(notification)"
            [class.read]="notification.read"
          >
            <mat-icon class="notification-icon">{{ notification.icon }}</mat-icon>
            <div class="notification-content">
              <p class="notification-message">{{ notification.notification_data }}</p>
             <!-- <span class="notification-timestamp">{{ notification.timestamp | date:'short' }}</span> -->
            </div>
          </div>
          <mat-divider *ngIf="!last"></mat-divider>
        </ng-container>
      </ng-container>

      <ng-template #noNotifications>
        <div class="no-notifications">
          <mat-icon>notifications_off</mat-icon>
          <p>No new notifications</p>
        </div>
      </ng-template>
    </mat-menu>
    <button
      mat-icon-button
      class="transparent-icon-button"
      title="Help"
      [matMenuTriggerFor]="helpMenu"
    >
      <mat-icon class="icon">help</mat-icon>
    </button>
    <mat-menu #helpMenu="matMenu" xPosition="before">
      <button mat-menu-item *ngFor="let file of helpFiles" (click)="openHelpFile(file.path)">
        <mat-icon>description</mat-icon>
        <span>{{ file.name }}</span>
      </button>
    </mat-menu>
    <button
      mat-icon-button
      class="transparent-icon-button"
      (click)="logout()"
      title="Logout"
    >
      <mat-icon class="icon">logout</mat-icon>
    </button>
  </div>
</mat-toolbar>
